import {Model} from '@adobe/cq-react-editable-components';
import {ComponentExporter} from '../../../../infrastructure/ComponentExporter';

export function getElement<T extends ComponentExporter>(
    items: {[key: string]: Model},
    name: string
): T | undefined {
    return items[name] as unknown as T;
}
